import React from 'react';
import { MapPin, Clock, Video, Calendar as CalendarIcon, ArrowRight } from 'lucide-react';
export function EventsCalendar() {
  const events = [{
    titleEs: 'Reunión de la Mesa Directiva',
    titleEn: 'Board Meeting',
    date: '12',
    month: 'JUN',
    fullDateEs: '12 de Junio, 2026',
    fullDateEn: 'June 12, 2026',
    time: '6:30 PM',
    location: 'Sylmar Recreation Center',
    isVirtual: true
  }, {
    titleEs: 'Comité de Uso de Suelo',
    titleEn: 'Land Use Committee',
    date: '05',
    month: 'JUN',
    fullDateEs: '5 de Junio, 2026',
    fullDateEn: 'June 5, 2026',
    time: '7:00 PM',
    location: 'Virtual vía Zoom',
    isVirtual: true
  }, {
    titleEs: 'Comité de Educación',
    titleEn: 'Education Committee',
    date: '08',
    month: 'JUN',
    fullDateEs: '8 de Junio, 2026',
    fullDateEn: 'June 8, 2026',
    time: '6:00 PM',
    location: 'Sylmar Library',
    isVirtual: false
  }, {
    titleEs: 'Comité de Seguridad Pública',
    titleEn: 'Public Safety Committee',
    date: '10',
    month: 'JUN',
    fullDateEs: '10 de Junio, 2026',
    fullDateEn: 'June 10, 2026',
    time: '7:00 PM',
    location: 'Virtual vía Zoom',
    isVirtual: true
  }];
  return <section id="calendar" className="py-24 px-6 lg:px-8 bg-white" data-id="element-36" data-mp="2b23lzwumbhdt">
      <div className="max-w-5xl mx-auto" data-id="element-37" data-mp="2p24kx6rboeqn">
        <div className="text-center mb-16" data-id="element-38" data-mp="2p13an4i4rw9z">
          <h2 className="text-3xl md:text-4xl font-bold text-charcoal mb-2 notranslate" data-id="element-39" data-mp="2l1ax0ddvqzxr">
            Calendario de Eventos
          </h2>
          <p className="text-xl text-sylmar font-medium notranslate" data-id="element-40" data-mp="2yr4mmxx7lo8j">
            Events Calendar
          </p>
          <div className="w-24 h-1 bg-warm mx-auto rounded-full mt-6" data-id="element-41" data-mp="2ttwd1lq4msiw"></div>
        </div>

        <div className="flex flex-col gap-4" data-id="element-42" data-mp="38rf2yrejjbrx">
          {events.map((event, index) => <div key={index} className="group flex flex-col md:flex-row gap-6 bg-white p-6 rounded-xl shadow-sm border border-gray-100 border-l-4 border-l-sylmar hover:shadow-md transition-all" data-id="element-43" data-mp="33sllknw4v0mh" data-mpi={index}>
              {/* Date Badge */}
              <div className="flex-shrink-0 flex flex-col items-center justify-center bg-sylmar-light text-sylmar rounded-lg w-20 h-20 border border-sylmar/20 group-hover:bg-sylmar group-hover:text-white transition-colors" data-id="element-44" data-mp="3kt6i35lqttjz">
                <span className="text-sm font-bold uppercase tracking-wider" data-id="element-45" data-mp="3uhoi3km77wmk">
                  {event.month}
                </span>
                <span className="text-3xl font-black leading-none mt-1" data-id="element-46" data-mp="2d46jg95p2p4">
                  {event.date}
                </span>
              </div>

              {/* Event Details */}
              <div className="flex-grow flex flex-col justify-center" data-id="element-47" data-mp="ccl8bmlaewft">
                <div className="flex flex-wrap items-center gap-3 mb-2" data-id="element-48" data-mp="2966lbhmm1i7o">
                  <div data-id="element-49" data-mp="2e482fx0h77gi">
                    <h3 className="text-xl font-bold text-charcoal group-hover:text-sky transition-colors leading-tight" data-id="element-50" data-mp="2e3olojmkap42">
                      {event.titleEs}
                    </h3>
                    <p className="text-sm text-sky-dark font-medium" data-id="element-51" data-mp="21tp5r9tw8hiq">
                      {event.titleEn}
                    </p>
                  </div>
                  {event.isVirtual && <span className="bg-sky/10 text-sky-dark text-xs font-bold px-2.5 py-1 rounded-full flex items-center gap-1 h-fit" data-id="element-52" data-mp="1rwksjzi0zwe2">
                      <Video className="w-3 h-3" data-id="element-53" data-mp="2pii1p6aimpdc" /> Opción Virtual / Virtual
                      Option
                    </span>}
                </div>

                <div className="flex flex-wrap gap-x-6 gap-y-2 text-sm text-gray-600 mt-2" data-id="element-54" data-mp="2fku9oo4anvyv">
                  <div className="flex items-center gap-1.5" data-id="element-55" data-mp="2an2812dukvhh">
                    <CalendarIcon className="w-4 h-4 text-sylmar" data-id="element-56" data-mp="2aon4ixjq2ohz" />
                    <span data-id="element-57" data-mp="1479qmeoxvvyc">
                      {event.fullDateEs}{' '}
                      <span className="text-gray-400 italic" data-id="element-58" data-mp="z742h8hvorl0">
                        ({event.fullDateEn})
                      </span>
                    </span>
                  </div>
                  <div className="flex items-center gap-1.5" data-id="element-59" data-mp="2ss1bvs297xkb">
                    <Clock className="w-4 h-4 text-sylmar" data-id="element-60" data-mp="2sudywjmvcy48" />
                    {event.time}
                  </div>
                  <div className="flex items-center gap-1.5 notranslate" data-id="element-61" data-mp="2j2hoc93ljfj4">
                    <MapPin className="w-4 h-4 text-sylmar" data-id="element-62" data-mp="2j2rfw14ahuqx" />
                    {event.location}
                  </div>
                </div>
              </div>

              {/* Action */}
              <div className="flex items-center md:justify-end mt-4 md:mt-0" data-id="element-63" data-mp="3bqdv66mvqntm">
                <button className="text-charcoal bg-gray-50 hover:bg-warm hover:text-charcoal px-4 py-2 rounded-lg font-semibold text-sm transition-colors border border-gray-200 hover:border-warm flex flex-col items-center" data-id="element-64" data-mp="2wt39y5kfq3kp">
                  <span data-id="element-65" data-mp="1ldemze76l4jw">Detalles</span>
                  <span className="text-xs font-normal text-gray-500" data-id="element-66" data-mp="1qdklnebvbrbh">
                    Details
                  </span>
                </button>
              </div>
            </div>)}
        </div>

        <div className="mt-12 text-center" data-id="element-67" data-mp="3hmfmpzr6cq6">
          <button className="inline-flex flex-col items-center justify-center gap-1 bg-charcoal hover:bg-charcoal-light text-white px-8 py-3 rounded-lg transition-colors shadow-lg" data-id="element-68" data-mp="3guts6vyjtd3">
            <div className="flex items-center gap-2 font-semibold" data-id="element-69" data-mp="dglkrylb7q8f">
              <CalendarIcon className="w-5 h-5" data-id="element-70" data-mp="3lukf6vsmv3jt" />
              Ver calendario completo
            </div>
            <span className="text-xs text-gray-300" data-id="element-71" data-mp="3gwsgnixhgj6n">View full calendar</span>
          </button>
        </div>
      </div>
    </section>;
}